import CharityService from "../../services/CharityService";
import LocationService from "../../services/LocationService";

export const GET_CHARITY_LIKE_REQUEST = "GET_CHARITY_LIKE_REQUEST";
export const GET_CHARITY_LIKE_SUCCESS = "GET_CHARITY_LIKE_SUCCESS";
export const GET_CHARITY_LIKE_ERROR = "GET_CHARITY_LIKE_ERROR";

export const TOGGLE_CHARITY_LIKE_REQUEST = "TOGGLE_CHARITY_LIKE_REQUEST";
export const TOGGLE_CHARITY_LIKE_SUCCESS = "TOGGLE_CHARITY_LIKE_SUCCESS";
export const TOGGLE_CHARITY_LIKE_ERROR = "TOGGLE_CHARITY_LIKE_ERROR";

export const getLike = (orderId) => {
  return dispatch => {
    dispatch({ type: GET_CHARITY_LIKE_REQUEST });
    CharityService.getCharityLike(orderId)
      .then(result => {
        dispatch({ type: GET_CHARITY_LIKE_SUCCESS, result });
      })
      .catch(err => {
        dispatch({ type: GET_CHARITY_LIKE_ERROR, error: err });
      });
  };
};

export const toggleLike = (orderId) => {
  return dispatch => {
    dispatch({ type: TOGGLE_CHARITY_LIKE_REQUEST });
    CharityService.toggleChatiryLike(orderId)
      .then(result => {
        dispatch({ type: TOGGLE_CHARITY_LIKE_SUCCESS, result });
      })
      .catch(err => {
        dispatch({ type: TOGGLE_CHARITY_LIKE_ERROR, error: err });
      });
  };
};
